import React from 'react'

export default class Cookies extends React.Component {

    constructor(props) {
        super(props)
        this.state = {hidden: this.props.hidden || localStorage && !!localStorage.getItem('accept_cookies')}
    }

    acceptCookies = () => {
        this.setState({hidden: true})
        // this.props.production && localStorage.setItem('accept_cookies', '1')
        localStorage && localStorage.setItem('accept_cookies', '1')
    }

    render() {
        if (this.state.hidden) return null
        return (
            <div className={'alert alert-info m-0 p-1'}>
                <div className={'container small'}>
                    {this.props.t.text}
                    <div className={'pull-right'}>
                        <a href={'#'}  onClick={this.acceptCookies}>{this.props.t.agree}</a>
                        <a href={'/gdpr'}><span className={'text-muted small ml-4'}>{this.props.t.more}</span></a>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        )
    }
}